import { recollectReasons } from './../../../../../../shared/const/recollect.const';
import { Component, Input, OnInit } from '@angular/core';
import { AbstractComponent } from '../../../../../../shared/definition/abstract/abstract.component';
import { HealthAnalysisModel } from '../../../model/health-analysis.model';
import { HEALTH_ANALYSIS_JOURNEY_STEPS } from '../../../health-analysis-journey-steps.const';
import { HealthAnalysisJourneyStepEnum } from '../../../enum/health-analysis-journey-step.enum';
import { sample } from 'rxjs';

@Component({
  selector: 'app-health-analysis-detail-general-data',
  templateUrl: './health-analysis-detail-general-data.component.html',
  styleUrl: './health-analysis-detail-general-data.component.scss'
})
export class HealthAnalysisDetailGeneralDataComponent extends AbstractComponent implements OnInit {
    @Input() analysis: HealthAnalysisModel;
    steps = HEALTH_ANALYSIS_JOURNEY_STEPS();

    expirationDateIcon: string;
    stabilityExpirationDateIcon: string;
    expirationDateTooltip = ''

    override ngOnInit() {
        this.initializeDeliveryAddress();
        this.getExpirationDateIcon()
        this.getStabilityExpirationDateIcon()
    }

    private initializeDeliveryAddress() {
        if (!this.analysis.prescriber || !this.analysis.detail?.address || this.analysis.detail.address.name) {
            return
        }

        this.analysis.detail.address.name = this.analysis.prescriber?.name;
        this.analysis.detail.address.documentNumber = this.analysis.prescriber?.documentNumber;
    }
    public getAddressStreet(): string {
        return `${this.analysis.detail.address.streetName }, ${this.analysis.detail.address.number }, ${this.analysis.detail.address.neighborhood}`
    }
    public getAddressStateAndCity(): string {
        return `${this.analysis.detail.address.city }, ${this.analysis.detail.address.state }, ${this.analysis.detail.address.zipCode.slice(0, 5) + '-' + this.analysis.detail.address.zipCode.slice(5)}`
    }
    public getAddressComplement(): string {
        let complement =  '';

        if (this.analysis.detail.address.complement) {
            complement += `Complemento: ${this.analysis.detail.address.complement} `;
        }
        if (this.analysis.detail.address.trackingCode) {
            complement += `Tracking Code: ${this.analysis.detail.address.trackingCode} Destinatário: ${this.analysis.detail.address.name}`;
        }

        return complement;
    }
    private getExpirationDateIcon() {
        if (this.analysis.step === HealthAnalysisJourneyStepEnum.COMPLETED) {
            this.expirationDateTooltip = 'Amostra finalizada'
        }

       const expirationPercentage = (Number(new Date()) - Number(new Date(this.analysis.expirationDate!))) /
            (Number(new Date(this.analysis.createdAt)) - Number(new Date(this.analysis.expirationDate!)));

        if (expirationPercentage >= 0.5) {
            this.expirationDateIcon = 'uii-circle-check';
            this.expirationDateTooltip = 'Amostra válida';
        } else if (expirationPercentage >= 0.25) {
            this.expirationDateIcon = 'uii-warning';
            this.expirationDateTooltip = 'Amostra próxima ao vencimento';
        } else if (expirationPercentage > 0) {
            this.expirationDateIcon = 'uii-circle-times';
            this.expirationDateTooltip = 'Amostra muito próxima do vencimento';
        } else {
            this.expirationDateIcon = 'uii-circle-times'
            this.expirationDateTooltip = 'Amostra vencida';
        }
    }
    private getStabilityExpirationDateIcon() {
       const expirationPercentage = (Number(new Date()) - Number(new Date(this.analysis.stabilityExpirationDate!))) /
            (Number(new Date(this.analysis.createdAt)) - Number(new Date(this.analysis.stabilityExpirationDate!)));

        if (expirationPercentage >= 0.5) {
            this.stabilityExpirationDateIcon = 'uii-circle-check';
        } else if (expirationPercentage >= 0.25) {
            this.stabilityExpirationDateIcon = 'uii-warning';
        } else if (expirationPercentage > 0) {
            this.stabilityExpirationDateIcon = 'uii-circle-times';
        } else {
            this.stabilityExpirationDateIcon = 'uii-circle-times'
        }
    }
    getAnalysisRecollectReason() {
        if (this.analysis.stepStatus?.description) return this.analysis.stepStatus?.description;

        return recollectReasons.find(elem => elem.value === this.analysis.stepStatus?.reason)?.name;
    }
    protected readonly sample = sample;
}
